export default {
  name: 'RefreshBtn',
  props: {
    type: {
      type: String,
      default: 'button'
    }
  },
  computed: {
    attrs() {
      return {
        ...this.$attrs,
        type: this.type
      }
    }
  }
}